import { render, staticRenderFns } from "./MyRecordings.vue?vue&type=template&id=3b16fd6e&scoped=true"
import script from "./MyRecordings.vue?vue&type=script&lang=js"
export * from "./MyRecordings.vue?vue&type=script&lang=js"
import style0 from "./MyRecordings.vue?vue&type=style&index=0&id=3b16fd6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16fd6e",
  null
  
)

export default component.exports